import moment from 'moment'
import {useMemo} from 'react'
import {useSearchParams} from 'react-router-dom'
import A1_CONSTANTS from '../core/_const'
import {isEqual} from 'lodash'

export const useA1OrderFilter = () => {
  const [searchParams] = useSearchParams()

  const initDateFilterValue = useMemo(
    () => ({
      date_from: moment().subtract(29, 'days').startOf('day').format(),
      date_to: moment().endOf('day').format(),
    }),
    []
  )

  const filters = useMemo(() => {
    let package_type: any = []
    let package_id: any = []
    const _packageInfo = searchParams.get('package_info') || null

    if (_packageInfo) {
      _packageInfo.split(',').forEach((packageItem) => {
        const convertPackage = Number.parseInt(packageItem)
        if (isEqual(convertPackage, NaN)) {
          package_type.push(packageItem)
        } else {
          package_id.push(packageItem)
        }
      })
    }

    const _filter = {}
    A1_CONSTANTS.PARAMS_A1_BATCHES_DETAIL_TABLE_FILTER.forEach((key) => {
      if (key === 'date_from' || key === 'date_to') {
        _filter[key] = searchParams.get(key) || initDateFilterValue[key]
      } else {
        _filter[key] = searchParams.get(key) || null
      }
    })
    return {
      ..._filter,
      package_type: package_type?.join(',') || null,
      package_id: package_id?.join(',') || null,
    }
  }, [initDateFilterValue, searchParams])

  return {filters}
}
